import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  dianying: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20spotlight%20and%20theater%20curtains%2C%20golden%20amber%20lighting%2C%20artistic%20minimal%20style%2C%20elegant%20composition%2C%20soft%20bokeh%20background&width=600&height=400&seq=cat-movie-01&orientation=landscape',
  dianshiju: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20television%20screen%20glowing%2C%20warm%20evening%20ambiance%2C%20soft%20lamp%20light%2C%20artistic%20minimal%20style%2C%20comfortable%20atmosphere&width=600&height=400&seq=cat-tv-01&orientation=landscape',
  zongyi: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20with%20soft%20spotlights%20and%20music%20atmosphere%2C%20vibrant%20warm%20colors%2C%20artistic%20abstract%20style%2C%20gentle%20gradient%20background&width=600&height=400&seq=cat-variety-01&orientation=landscape',
  jilupian: 'https://readdy.ai/api/search-image?query=Majestic%20mountain%20landscape%20through%20camera%20lens%2C%20warm%20earthy%20tones%2C%20golden%20hour%20lighting%2C%20artistic%20minimal%20style%2C%20documentary%20aesthetic&width=600&height=400&seq=cat-doc-01&orientation=landscape',
  dongman: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20art%20style%20illustration%20with%20warm%20gradient%20colors%2C%20creative%20composition%2C%20soft%20lighting%2C%20artistic%20minimal%20background&width=600&height=400&seq=cat-anime-01&orientation=landscape',
  shaoer: 'https://readdy.ai/api/search-image?query=Colorful%20playful%20children%20toys%20and%20books%20arrangement%2C%20warm%20pastel%20colors%2C%20soft%20natural%20light%2C%20artistic%20minimal%20style%2C%20gentle%20atmosphere&width=600&height=400&seq=cat-kids-01&orientation=landscape',
};

const CategoriesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4">
            内容分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">
            海量内容，
            <span className="text-accent-500">随心选择</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            涵盖电影、电视剧、综艺、纪录片、动漫、少儿等丰富内容类型，满足全家人的在线观看需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-200/40 transition-all duration-300 hover:-translate-y-1 no-underline"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={categoryImages[category.slug]}
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 px-2.5 py-1 bg-background-950/60 backdrop-blur-sm rounded-full text-xs text-background-200">
                  {category.itemCount.toLocaleString()}部
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                    <i className={`${category.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-lg font-heading text-foreground-950">{category.name}</h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{category.description}</p>
                <div className="mt-3 flex items-center gap-1 text-accent-600 text-sm font-medium group-hover:gap-2 transition-all">
                  浏览全部 <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;